import type { JSX } from 'react';

import { Activities, ActivityConfig } from '../../enums/Activities';
import { EmptyDataIconWithTooltip } from '../elements/EmptyDataIcon';
import { TimerValueComponent } from '../elements/TimerValueComponent';
import type { DurationAndItems } from './types';

interface WeeklyRestMinimumCellProps {
    value?: DurationAndItems;
}

export const WeeklyRestMinimumCell = (props: WeeklyRestMinimumCellProps): JSX.Element => {
    const { value } = props;

    if (!value || value.duration === undefined) {
        return <EmptyDataIconWithTooltip />;
    }

    return (
        <div className={'display-flex'}>
            <TimerValueComponent
                minutes={value.duration}
                color={ActivityConfig[Activities.RESTING].color}
                size={'16'}
            />
        </div>
    );
};
